import * as React from "react"
import { cva } from "class-variance-authority";

import { cn } from "../../lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-full px-3 py-1 text-xs font-medium transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "bg-primary/20 text-primary border border-primary/30 hover:bg-primary/30",
        secondary:
          "bg-secondary/20 text-secondary-foreground border border-secondary/30 hover:bg-secondary/30",
        destructive:
          "bg-destructive/20 text-destructive border border-destructive/30 hover:bg-destructive/30",
        success:
          "bg-success-500/20 text-success-400 border border-success-500/30 hover:bg-success-500/30",
        warning:
          "bg-warning-500/20 text-warning-400 border border-warning-500/30 hover:bg-warning-500/30",
        gold:
          "bg-gradient-to-r from-gold-500/20 to-gold-600/20 text-gold-400 border border-gold-500/30 hover:bg-gradient-to-r hover:from-gold-500/30 hover:to-gold-600/30 shadow-glow",
        outline: "text-foreground border border-border hover:bg-accent",
        glass: "bg-white/10 backdrop-blur-sm border border-white/20 text-foreground hover:bg-white/20",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

function Badge({
  className,
  variant,
  ...props
}) {
  return (<div className={cn(badgeVariants({ variant }), className)} {...props} />);
}

export { Badge, badgeVariants }
